import type { DashboardSpec } from "../dashboard/catalog"

import { cn } from "@/lib/utils"

import { DashboardRenderer } from "../dashboard/dashboard-renderer"

type DashboardMiniPreviewProps = {
  spec: DashboardSpec
  className?: string
}

/**
 * A scaled-down, non-interactive preview of a dashboard.
 * Used in landing page tiles to show a mini version of the dashboard on hover.
 */
export function DashboardMiniPreview({ spec, className }: DashboardMiniPreviewProps) {
  return (
    // `inert`: the preview renders the real dashboard, whose buttons (e.g. the
    // "Select tile" keyboard route) would otherwise sit in the tab order between
    // a tile's "More actions" button and its title, and be read by AT.
    <div inert className={cn("overflow-hidden", className)}>
      <div
        className="pointer-events-none origin-top-left"
        style={{ transform: "scale(0.35)", width: "286%", height: "286%" }}
      >
        <DashboardRenderer spec={spec} syncStateToUrl={false} />
      </div>
    </div>
  )
}
